/**
 * Checks whether the page is running inside the Hotwire Native mobile app
 * @returns {boolean}
 */
export function isMobileApp() {
  return document.documentElement.classList.contains('amba-mobile-app');
}
